import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* Brand Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img
                src="/Images/Ace Dental Lab Logo Svg.svg"
                alt="Ace Dental Lab Logo"
                className="h-14 w-auto"
              />
            </Link>

            <p className="text-white text-sm leading-relaxed max-w-sm">
              Ace Dental Lab delivers precision-crafted restorations through
              advanced technology and expert dental care.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold mb-4 uppercase tracking-wide text-gray-300">
              Contact Info
            </h3>

            <div className="space-y-3 text-sm text-white">
              <div className="flex items-start gap-3">
                <MapPin size={16} />
                <a
                  href="https://www.google.com/maps?q=501+E+Roosevelt+Road+Lombard+IL+60148"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white cursor-pointer"
                >
                  501 E Roosevelt Road<br />
                  Lombard, Illinois 60148
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Phone size={16} />
                <a href="tel:+16308661646" className="hover:text-white">
                  (630) 866-1646
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Mail size={16} />
                <a href="mailto:lab2@acedentalcenter.com" className="hover:text-white">
                  Lab2@acedentalcenter.com
                </a>
              </div>

              <div className="flex items-center gap-3">
                <Instagram size={16} />
                <a
                  href="https://www.instagram.com/acedentallab?igsh=MWIxOTh4ZTYzeGQ4Mg=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  @acedentallab
                </a>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-sm font-semibold mb-4 uppercase tracking-wide text-white">
              Hours
            </h3>

            <div className="flex items-start gap-3 text-sm text-white">
              <Clock size={16} />
              <div>
                <div>Mon–Fri: 8:30 AM – 4:30 PM</div>
                <div>Saturday: 9:00 AM – 2:00 PM</div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold mb-4 uppercase tracking-wide text-gray-300">
              Quick Links
            </h3>

            <nav className="space-y-2 text-sm text-white">
              <Link
                to="/"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block hover:text-white"
              >
                Home
              </Link>

              <Link
                to="/about"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block hover:text-white"
              >
                About
              </Link>

              <Link
                to="/showcase"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block hover:text-white"
              >
                Showcase
              </Link>

              <Link
                to="/product"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block hover:text-white"
              >
                Products
              </Link>

              <Link
                to="/workflow"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block hover:text-white"
              >
                Workflow
              </Link>

              <Link
                to="/contact"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="block hover:text-white"
              >
                Contact Us
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar border-t  */}
        <div className="border-gray-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-white">
          <p>
            © {new Date().getFullYear()} Ace Dental Lab. All rights reserved.
            Powered by{" "}
            <a
              href="https://epic-sphere.com/"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white"
            >
              ES
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
